import React, { useState, useEffect, useContext } from 'react';
import { Row, Col } from 'react-bootstrap'
import Get from '../../api/Get'
import Post from '../../api/Post'
import { ESPECIALITIES_LIST, ESPECIALITIES_UDPDATE } from "../../api/Routes";
import { ESPECIALITIES_ADD } from "../../api/Routes";
import { authContext } from "../../context/AuthContext";
import EspecialidadesList from "./especialidades/EspecialidadesList";
import AddEspecialidad from "./especialidades/AddEspecialidad";
import Filtro from '../../components/catalogos/Filtro';
import LoadingList from "../../loader/LoadingList";

import '../../styles/catalogos/catalogos.css'
import { toBool } from '../../utils/toBool';
import Put from '../../api/Put';
import ComponentModalErrorSever from '../../components/ComponentModalErrorSever';

function EspecialidadesIndex(){

    //Parametros para actualizar la tabla
    const [items, setItems] = useState([])
    const [initialValues, setInitialValues] = useState({name:''})
    const [loading, setLoading] = useState(false)

    //Token de autentificación para los servicios
    const {auth} = useContext(authContext)

    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    useEffect(() => cargarEspecialidades(), [])

    const cargarEspecialidades = () => {
        setLoading(true)

        Get({url: ESPECIALITIES_LIST, access_token: auth.data.access_token})
        .then((resp) => {
            let data = resp.data.data.response;
            setItems(data.content ?? [])
            setLoading(false)
        })
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
    }

    const agregarEspecialidad = (values) => {
        values.active = "true";
        values.companies = [auth.data.company]

        setLoading(true)

        setTimeout(() => {
            Post({url: ESPECIALITIES_ADD, data: values, header:true, access_token:auth.data.access_token})
            .then((response) => {
                setItems(prev=>[...prev, response.data])
                setInitialValues({name:''})
                setLoading(false)  
            })                
            .catch((error) => {
                setShowModalError(true)
                if(error.response){
                    setErrorServer(error.response)
                }
                setLoading(false)   
            })
        }, 1000);

    }

    const editarElemento = (values) =>{
        if(toBool(values.active)){
            values.companies.push(auth.data.company)
        }else{
            let arr = values.companies.filter(el => el.id !== auth.data.company.id)
            values.companies = arr
        }      

        Put({url: ESPECIALITIES_UDPDATE, data: values, header:true, access_token:auth.data.access_token})
        .then((response) => {
            //ok      
        })                
        .catch((error) => {
            setLoading(false)        
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
    }

    return(<>
        {loading && <LoadingList texto='' />}

        <div className="body">
            <Filtro catName ='Especialidades'/>
            <Row>
                <Col xs="6" md="6">
                {!loading && <AddEspecialidad agregarEspecialidad={agregarEspecialidad} initialValues={initialValues} />}
                </Col>
                <Col xs="6" md="6">
                    <EspecialidadesList items={items} 
                        editarElemento={editarElemento}
                        auth={auth}
                    />
                </Col>
            </Row>
        </div>
        <ComponentModalErrorSever 
            show={showModalError}
            handleClose={handleClose}
            error={errorServer}
        />
    </>)
}

export default EspecialidadesIndex